import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./assets/styles/theme.scss";
import axios from "axios";

if (process.env.NODE_ENV === "production") {
  console.error = () => {};
  console.warn = () => {};
  console.log = () => {};
}

const app = createApp(App);

app.config.errorHandler = (error) => {
  console.error("Global error:", error);
  router.push("/error");
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAuthEndpoint = error.config?.url?.includes("/auth/");
    if (error.response?.status === 401 && !isAuthEndpoint) {
      localStorage.removeItem("jwt");
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

app.use(router).mount("#app");
